import { createStore, useStore } from 'zustand';

const orphanCommentsStore = createStore((set, get) => ({
  orphanMap: /* @__PURE__ */ new Map(),
  setOrphan: (commentId, resourceId, orphan) => {
    set((state) => ({
      orphanMap: new Map(state.orphanMap).set(`${commentId}-${resourceId}`, orphan)
    }));
  },
  isOrphan: (commentId, resourceId) => {
    return get().orphanMap.get(`${commentId}-${resourceId}`) ?? false;
  }
}));
const useIsCommentOrphan = (commentId, resourceId) => {
  const orphan = useStore(orphanCommentsStore, (state) => state.orphanMap.get(`${commentId}-${resourceId}`));
  const setOrphan = useStore(orphanCommentsStore, (state) => (orphan2) => state.setOrphan(commentId, resourceId, orphan2));
  return [
    orphan ?? false,
    setOrphan
  ];
};
const isCommentOrphan = (commentId, resourceId) => {
  return orphanCommentsStore.getState().isOrphan(commentId, resourceId);
};
const setIsCommentOrphan = (commentId, resourceId, orphan) => {
  return orphanCommentsStore.getState().setOrphan(commentId, resourceId, orphan);
};

export { isCommentOrphan, orphanCommentsStore, setIsCommentOrphan, useIsCommentOrphan };
//# sourceMappingURL=orphanCommentsStore.js.map
